// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-B2X7p","menu_item":"menu_item-Lkd5f"};